import React, { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/brand/Logo";

// Handles the Emergent Google OAuth return: reads #session_id, exchanges it, then redirects.
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { completeGoogle } = useAuth();
  const done = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        await completeGoogle(sessionId);
        window.history.replaceState(null, "", "/home");
        navigate("/home", { replace: true });
      } catch (e) {
        setError(e.message || "Sign-in failed.");
      }
    })();
  }, [location.hash, completeGoogle, navigate]);

  return (
    <div className="grid min-h-screen place-items-center bg-am-bg px-6">
      <div className="flex flex-col items-center gap-5 text-center">
        <div className="animate-pulse"><Logo size={64} /></div>
        {error ? (
          <>
            <p className="text-sm text-am-text2">{error}</p>
            <button onClick={() => navigate("/login")} className="rounded-full bg-white px-5 py-2 text-sm font-semibold text-black">Back to login</button>
          </>
        ) : (
          <p className="text-sm text-am-text2">Activating your Aura…</p>
        )}
      </div>
    </div>
  );
}
